export var DialogDimension;
(function (DialogDimension) {
    DialogDimension["Large"] = "large";
    DialogDimension["Medium"] = "medium";
    DialogDimension["Small"] = "small";
})(DialogDimension || (DialogDimension = {}));
export var DialogContentType;
(function (DialogContentType) {
    DialogContentType["Card"] = "card";
    DialogContentType["Url"] = "url";
})(DialogContentType || (DialogContentType = {}));
//# sourceMappingURL=dialog.js.map